import React from 'react'
import { ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import ErrorBoundary from '@/components/ErrorBoundary'
import { EditCycleParametersContent } from './content'
import { fromUtcDate } from '@/utils/dateUtilities'

export const EditCycleParametersDialog = (props) => {
  const [dates, setDates] = React.useState(props.dates.map(x => fromUtcDate(x)))
  const [weeks, setWeeks] = React.useState(props.weeks)
  return (
    <React.Fragment>
      <BasicHeader title='Reporting.ParametersTitle' {...props} />
      <ModalBody>
        <ErrorBoundary>
          <EditCycleParametersContent
            localize={props.localize}
            onAddDate={date => setDates([...dates, date])}
            onRemoveDateAt={index => setDates(dates.filter((v, idx) => idx !== index))}
            onWeekAdd={week => setWeeks([...weeks, week])}
            onRemoveWeekAt={index => setWeeks(weeks.filter((v, idx) => idx !== index))}
            dates={dates}
            weeks={weeks}
            loading={props.loading || props.saving}
            disabled={props.disabled}
          />
        </ErrorBoundary>
      </ModalBody>
      <ConfirmFooter disabled={props.disabled} primaryButtonText='Common.SaveAndClose' icon='save' {...props} onAction={() => props.onAction({ dates, weeks })} />
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/dialogs/editCycleParameters/dialog.js